/* La Planque — la visite (thème Shopify). Médias servis depuis LP.mediaBase (CORS ouvert). */
(function () {
  const M = window.LP.mediaBase + "/visite";
  const W0 = 2.4;
  const W1 = 2.4;

  mountScrollWorld(document.getElementById("world"), {
    brand: { name: "LA PLANQUE", href: window.LP.rootUrl },
    hint: "scroll · entre dans la planque",
    nav: false,
    atmosphere: false,
    crossfade: 0.06,
    sections: [
      {
        id: "cuisine", label: "La cuisine",
        still: M + "/k0.webp",
        clip: M + "/t0.mp4",
        accent: "#7FAE8F", scroll: W0, linger: 0.3,
        eyebrow: "Rien n'est ce qu'il semble",
        title: "Bienvenue dans la planque.",
        body: "Il est tard. L'appartement dort. Avance : chaque objet banal cache quelque chose.",
        tags: ["Visite de nuit"]
      },
      {
        id: "salon", label: "Le salon",
        still: M + "/k1.webp",
        clip: M + "/t1.mp4",
        accent: "#7FAE8F", scroll: W1, linger: 0.3,
        eyebrow: "Cachette n°02 · Salon",
        title: "L'Horloge-Coffre",
        body: "Elle donne l'heure. Elle garde le reste. La suite de la visite arrive bientôt.",
        cta: { primary: { label: "Découvrir la boutique", href: window.LP.rootUrl } }
      }
    ],
    connectors: [null]
  });

  /* ---- Arrêt n°1 : les canettes, sur la couture T0→T1 ---- */
  const stop = document.getElementById("stop-canettes");
  const openVid = document.getElementById("open-canette");
  const hotspot = stop.querySelector(".stop-hotspot");
  let inBand = false, opened = false;

  function onScroll() {
    const vh = window.innerHeight;
    const y = window.scrollY || window.pageYOffset;
    const seam = W0 * vh;
    const band = y > seam - 0.35 * vh && y < seam + 0.35 * vh;
    if (band !== inBand) {
      inBand = band;
      stop.classList.toggle("on", band);
      if (!band && opened) closeOpenVideo();
    }
  }

  function closeOpenVideo() {
    opened = false;
    openVid.classList.remove("on");
    setTimeout(() => { try { openVid.pause(); openVid.currentTime = 0; } catch (e) {} }, 260);
  }

  hotspot.addEventListener("click", () => {
    if (opened) { closeOpenVideo(); return; }
    opened = true;
    openVid.classList.add("on");
    try { openVid.currentTime = 0; openVid.play(); } catch (e) {}
  });
  openVid.addEventListener("click", closeOpenVideo);

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  onScroll();
})();
